import { ReactNode } from 'react';
import { ButtonSizeEnum } from '../JxtButton/types';

export enum AnchorVariantEnum {
  Link = 'link',
  LinkDark = 'link-dark',
}

export interface IJxtAnchor {
  /**
   * Variant of the anchor, it can take the following options:
   * @default link
   */
  variant?: AnchorVariantEnum;

  /**
   * Size of the anchor, it can take the following options:
   * @default regular
   */
  size?: ButtonSizeEnum;

  /**
   * The URL to navigate to.
   */
  href: string;

  /**
   * Whether the link should open in a new window/tab.
   * @default false
   */
  newWindow?: boolean;

  /**
   * Classname to add to the inner anchor element.
   * @default ''
   */
  className?: string;

  /**
   * Content of the anchor, it can be some text or React Node.
   */
  children?: ReactNode;
}
